var CollectionView = require('views/base/collection-view');
import AsyncBlockService from 'services/async-block-service';

var GlossaryCollectionView = CollectionView.extend({
  template: require('./templates/glossary-collection'),
  itemView: Chaplin.View,
  listSelector: '.glossary-list',
  autoRender: true,
  initialize: function() {
    AsyncBlockService.load([ 'glossary' ], [ 'views/block/glossary/glossary-item-view' ]).then(([ GlossaryItemView ]) => {
      this.itemView = GlossaryItemView;
      if(this.autoRender) {
        this.render();
      }
    });
    CollectionView.prototype.initialize.apply(this, arguments);
  }
});

module.exports = GlossaryCollectionView;
